import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Sparkles from '@/components/Sparkles';

const Demos = () => {
  return (
    <Wrapper>
      <Cell>
        <Title>Constant Interval</Title>
        <CellContents>
          <Sparkles minSize={30} maxSize={30} rate={500} variance={0}>
            Sparkle Text
          </Sparkles>
        </CellContents>
      </Cell>
      <Cell>
        <Title>Random Interval</Title>
        <CellContents>
          <Sparkles
            minSize={30}
            maxSize={30}
            rate={500}
            variance={450}
          >
            Sparkle Text
          </Sparkles>
        </CellContents>
      </Cell>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  display: flex;

  @media ${BREAKPOINTS.smAndSmaller} {
    flex-direction: column;
  }
`;

const Cell = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
`;

const CellContents = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title = styled.div`
  font-size: 1rem;
  font-weight: var(--font-weight-medium);
  background: var(--color-code-bg);
  border-radius: 6px;
  margin: 1px;
  margin-bottom: 16px;
  padding-block: 6px;
  text-align: center;
`;

export default Demos;
